const defaultState = {
  config: {},
  clearConfig: {},
};

function appConfig(state = defaultState, action) {
  switch (action.type) {
    // No need to clear state for appConfig, cause it's already static for every env
    // case 'CLEAR_STATE':
    //   return defaultState
    case 'INIT_CONFIG':
      return { ...state, config: { ui_labels: state.config.ui_labels || {}, ...action.config }, clearConfig: action.clearConfig };
    case 'INIT_FIELD_NAMING':
      return { ...state, config: { ...state.config, ui_labels: action.uiLabels } };
    case 'UPDATE_UI_LABELS':
      return {
        ...state,
        config: {
          ...state.config,
          ui_labels: { ...state.config.ui_labels, ...action.uiLabel },
        },
      };
    default:
      return state;
  }
}

export default appConfig;
